import { isVoucherApplicable } from 'helpers/src/vouchers/isVoucherApplicable';
import { IVoucherGroup, IItem } from 'helpers/src/vouchers/interfaces/calculateVouchers';

export const calculatePriceOfItemByVoucher = (
  item: any, 
  group: IVoucherGroup, 
  orderTotal: number, 
  currencyId: string,
  customerGroupId: string | null | string[],
  orderItems: Array<any>,
) => {
  // voucher je možné aplikovat na cenu položky
  if (isVoucherApplicable({
      variantId: item.variant && item.variant.id || item.variantId,
      price: item.price,
      recommendedPrice: item.recommendedPrice,
      tags: item.variant ? item.variant.tags as any : [],
    }, group, orderTotal, currencyId, customerGroupId)) {
    const price = group && group.source && group.source.toLowerCase() === 'price' 
      ? item.price 
      : item.recommendedPrice;

    const variantId = item.variantId || (item.variant && item.variant.id);
    const orderItem = orderItems.find((oi: any) => {
      const vId = oi.variantId || (oi.variant && oi.variant.id);
      return vId === variantId; 
    });

    // if there is voucher discount amount, convert any type of voucher group to amount voucher group
    if (('number' === typeof group.voucherDiscountAmount) && (group.voucherDiscountAmount >= 0)) {
      group.type = 'amount';
      group.amount = group.voucherDiscountAmount;
      group.fixDiscountAmount = [];
    }

    switch (group.type) {
      case 'percent': return (price / 100) * (100 - group.amount);

      case '2+1':
        if (group.type === '2+1'
          && group.includedProducts.indexOf(variantId) > -1
          && orderItem.quantity > 2) {
          const diff = parseInt(String(orderItem.quantity / 3), 10);
          return item.price / orderItem.quantity * (orderItem.quantity - diff);
        }
        return Math.round(item.price * 100) / 100;

      case 'gift':
        if (group.type === 'gift' && group.giftId === variantId) {
          const amount = orderItems.reduce((acc: number, it: any) => {
            const vId = it.variantId || (it.variant && it.variant.id);
            if (group.includedProducts.indexOf(vId) > -1) {
              return acc + it.quantity;
            }
      
            return acc;
          }, 0);
    
          const i = orderItems.find((oi: any) => {
            const vId = oi.variantId || (oi.variant && oi.variant.id);
            return vId === variantId;  
          });
    
          const diff = i.quantity - (amount / 100 * group.amount);
          if (diff <= 0) {
            return 0;
          }
    
          const unitPrice = diff * price / i.quantity;
          return Math.round(unitPrice * 100) / 100;
        }
        return item.price;

      default:
        return item.price;
    }

  }

  return item.price;
};



// WEBPACK FOOTER //
// ../helpers/src/vouchers/calculatePriceOfItemByVoucher.ts